import { render, staticRenderFns } from "./InfractionTypeList.vue?vue&type=template&id=66a9c430"
import script from "./InfractionTypeList.vue?vue&type=script&lang=js"
export * from "./InfractionTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports